<template>
    <pm-custom-dialog v-if="visible" v-model="visible">
        <div style="margin-bottom: 16px; margin-top: 20px; text-align: center;">

            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                We are here to help
            </h2>
        </div>


        <template v-if="!reason">

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
                Please tell us what was your problem with the subscription.
            </p>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='account_login'">
                I CAN'T LOGIN TO MY ACCOUNT
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='add_payment'">
                I CAN'T ADD PAYMENT
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='payment_refused'">
                PAYMENT REFUSED
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='other'">
                OTHER
            </a>
            <br/>
            <a class="close-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="reason = 'close'">
                <v-icon style="color: #2962ff; font-size:16px; margin-right: 6px;">close</v-icon> CLOSE
            </a>
        </template>

        <template v-if="reason">

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
                If you have any difficulties with the subscription, please tell us what was your problem.
            </p>
            <br/>

            <v-text-field style="width: Calc(100%-40px); margin: 0 20px;" type="email" ref="reviewEmail" box id="feedback-email-input" v-model="email" :placeholder="$t('support.email')" />

            <v-textarea style="margin: 0 30px; --delay: 100ms" class="pm-animation-fade-in-slide-down" id="feedback-textarea"
                outline
                placeholder="What was your problem"
                name="feedback"
                v-model="details"
                hide-details
            ></v-textarea>

            <br/>
            <a class="blue retry-btn mb-3 pm-animation-fade-in-slide-down" style="color: #fff; width: 150px; --delay: 50ms" @click="submit">
                SEND
            </a>
            <br/>
            <a class="close-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="reason = 'close'">
                <v-icon style="color: #2962ff; font-size:16px; margin-right: 6px;">close</v-icon> CLOSE
            </a>
        </template>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { callSlackWebhook } from "@/utils/webhooks/slack";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        email: localStorage.getItem('userEmailSend') || localStorage.getItem('userEmail') || "",
        reason: "",
        details: "",
    }),
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
        reason() {
            localStorage.setItem('storeSupportReason', this.reason);
            window.Tracker.logEvent({
                event_name: "support_reason",
                event_category: "iap",
                event_label: this.reason,
            });
            if (this.reason === 'close') this.close();
        },
    },
    methods: {
        show() {
            this.reason = "";
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        submit() {
            const params = [
                "#denticalc-feedback",
                "Need help subscribing - " + this.email + " - " + this.details,
                true,
            ];
            callSlackWebhook(...params);
            this.close();
        },
    }
}
</script>
